import { ref, push, set, update, remove, onValue } from 'firebase/database'
import { db, tref } from './firebase.js'
import { logActivity } from './activity.js'
import { ROLES } from './roles.js'

// Employees. /club/employees. Roles power permissions (see roles.js). Clock
// in/out records + commission rate. Sales attribution is computed from /club/sales.
//   {id}: { name, role, commissionPct, active, clockRecords:{}, createdAt }
const BASE = 'club/employees'
export { ROLES }
const num = (v) => (v === '' || v == null ? 0 : Number(v) || 0)

export function watchEmployees(cb) { return onValue(tref(BASE), (s) => cb(s.val() || {})) }
export async function createEmployee(d) {
  const name = String(d.name || '').trim(); if (!name) throw new Error('Employee name is required.')
  const node = push(tref(BASE))
  await set(node, { id: node.key, name, role: ROLES.includes(d.role) ? d.role : 'staff', commissionPct: num(d.commissionPct), active: true, clockRecords: {}, createdAt: Date.now() })
  logActivity({ type: 'employee', icon: '🧑‍💼', text: `Employee added: ${name}` })
  return node.key
}
export async function updateEmployee(id, patch) {
  const clean = {}
  if (patch.name != null) clean.name = String(patch.name).trim()
  if (patch.role != null) clean.role = patch.role
  if (patch.commissionPct !== undefined) clean.commissionPct = num(patch.commissionPct)
  if (patch.active !== undefined) clean.active = !!patch.active
  await update(tref(`${BASE}/${id}`), clean)
}
export function clockStatus(emp) {
  const recs = Object.entries(emp?.clockRecords || {}).map(([id, r]) => ({ id, ...r })).sort((a, b) => (b.in || 0) - (a.in || 0))
  const open = recs.find((r) => r.in && !r.out)
  return { open, recs }
}
export async function clockIn(id) {
  const k = push(tref(`${BASE}/${id}/clockRecords`)).key
  await update(tref(`${BASE}/${id}`), { [`clockRecords/${k}`]: { in: Date.now(), out: null } })
}
export async function clockOut(id, recordId) {
  await update(tref(`${BASE}/${id}/clockRecords/${recordId}`), { out: Date.now() })
}
export async function deleteEmployee(id) { await remove(tref(`${BASE}/${id}`)) }
